var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", md: "5" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("sidebar.settings")))]),
              _c(
                "w-card-content",
                [
                  _c("w-switch", {
                    attrs: { label: _vm.$ct("sidebar.enabled"), space: "" },
                    model: {
                      value: _vm.sidebar.Enabled,
                      callback: function ($$v) {
                        _vm.$set(_vm.sidebar, "Enabled", $$v)
                      },
                      expression: "sidebar.Enabled",
                    },
                  }),
                  _c(
                    "w-row",
                    [
                      _c(
                        "w-col",
                        { attrs: { xs: "12" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.triggerItems,
                              label: _vm.$ct("sidebar.trigger"),
                              fancy: "",
                              disabled: !_vm.sidebar.Enabled,
                            },
                            model: {
                              value: _vm.sidebar.Trigger,
                              callback: function ($$v) {
                                _vm.$set(_vm.sidebar, "Trigger", $$v)
                              },
                              expression: "sidebar.Trigger",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-select", {
                            attrs: {
                              items: _vm.positionItems,
                              label: _vm.$ct("sidebar.position"),
                              fancy: "",
                              disabled: !_vm.sidebar.Enabled,
                            },
                            model: {
                              value: _vm.sidebar.Position,
                              callback: function ($$v) {
                                _vm.$set(_vm.sidebar, "Position", $$v)
                              },
                              expression: "sidebar.Position",
                            },
                          }),
                        ],
                        1
                      ),
                      _c(
                        "w-col",
                        { attrs: { xs: "12", md: "6" } },
                        [
                          _c("w-input-number", {
                            attrs: {
                              label: _vm.$ct("sidebar.width"),
                              fancy: "",
                              decimals: 0,
                              min: 240,
                              disabled: !_vm.sidebar.Enabled,
                            },
                            model: {
                              value: _vm.sidebar.Width,
                              callback: function ($$v) {
                                _vm.$set(_vm.sidebar, "Width", $$v)
                              },
                              expression: "sidebar.Width",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm.sidebar.Enabled
                    ? _c("w-info", {
                        staticClass: "mt",
                        attrs: {
                          tiny: "",
                          text: _vm.$ct("sidebar.iframe-info"),
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "w-card",
            { staticClass: "mt" },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("sidebar.header")))]),
              _c(
                "w-card-content",
                [
                  _c(
                    "w-list",
                    [
                      _c("w-list-subheader", [
                        _vm._v(_vm._s(_vm.$ct("sidebar.title-field"))),
                      ]),
                      _vm.sidebar.TitleField
                        ? _c(
                            "w-list-item",
                            [
                              _c("w-list-item-text", [
                                _vm._v(
                                  _vm._s(_vm.sidebar.TitleField.Name) + " "
                                ),
                                _c("span", { staticClass: "gray" }, [
                                  _vm._v(
                                    "(" +
                                      _vm._s(
                                        _vm.getFieldFriendlyName(
                                          _vm.sidebar.TitleField
                                        )
                                      ) +
                                      ")"
                                  ),
                                ]),
                              ]),
                              _c(
                                "w-list-item-action",
                                [
                                  _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct("sidebar.edit-field"),
                                          expression:
                                            "$ct('sidebar.edit-field')",
                                        },
                                      ],
                                      on: {
                                        click: function ($event) {
                                          return _vm.editHeaderField(
                                            "title",
                                            _vm.sidebar.TitleField,
                                            -1
                                          )
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "pen" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "w-list-item-action",
                                [
                                  _c(
                                    "w-button",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: _vm.$ct(
                                            "sidebar.remove-field"
                                          ),
                                          expression:
                                            "$ct('sidebar.remove-field')",
                                        },
                                      ],
                                      staticClass: "danger",
                                      on: {
                                        click: function ($event) {
                                          _vm.sidebar.TitleField = null
                                        },
                                      },
                                    },
                                    [_c("w-fa", { attrs: { icon: "trash" } })],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          )
                        : _c(
                            "w-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editHeaderField("title", null, -1)
                                },
                              },
                            },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "plus" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(
                                  _vm._s(_vm.$ct("sidebar.choose-title-field"))
                                ),
                              ]),
                            ],
                            1
                          ),
                      _c("w-list-subheader", [
                        _vm._v(_vm._s(_vm.$ct("sidebar.subtitle-fields"))),
                      ]),
                      _vm._l(_vm.sidebar.SubtitleFields, function (field, i) {
                        return _c(
                          "w-list-item",
                          { key: "sub" + i },
                          [
                            _c("w-list-item-text", [
                              _vm._v(_vm._s(field.Name) + " "),
                              _c("span", { staticClass: "gray" }, [
                                _vm._v(
                                  "(" +
                                    _vm._s(_vm.getFieldFriendlyName(field)) +
                                    ")"
                                ),
                              ]),
                            ]),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("sidebar.edit-field"),
                                        expression: "$ct('sidebar.edit-field')",
                                      },
                                    ],
                                    on: {
                                      click: function ($event) {
                                        return _vm.editHeaderField(
                                          "subtitle",
                                          field,
                                          i
                                        )
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "pen" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                            _c(
                              "w-list-item-action",
                              [
                                _c(
                                  "w-button",
                                  {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: _vm.$ct("sidebar.remove-field"),
                                        expression:
                                          "$ct('sidebar.remove-field')",
                                      },
                                    ],
                                    staticClass: "danger",
                                    on: {
                                      click: function ($event) {
                                        return _vm.sidebar.SubtitleFields.splice(
                                          i,
                                          1
                                        )
                                      },
                                    },
                                  },
                                  [_c("w-fa", { attrs: { icon: "trash" } })],
                                  1
                                ),
                              ],
                              1
                            ),
                          ],
                          1
                        )
                      }),
                      _vm.sidebar.SubtitleFields.length < 3
                        ? _c(
                            "w-list-item",
                            {
                              on: {
                                click: function ($event) {
                                  return _vm.editHeaderField(
                                    "subtitle",
                                    null,
                                    -1
                                  )
                                },
                              },
                            },
                            [
                              _c(
                                "w-list-item-icon",
                                [_c("w-fa", { attrs: { icon: "plus" } })],
                                1
                              ),
                              _c("w-list-item-text", [
                                _vm._v(
                                  _vm._s(_vm.$ct("sidebar.add-subtitle-field"))
                                ),
                              ]),
                            ],
                            1
                          )
                        : _vm._e(),
                    ],
                    2
                  ),
                  !_vm.sidebar.TitleField &&
                  _vm.sidebar.SubtitleFields.length == 0
                    ? _c("w-info", {
                        staticClass: "mt",
                        attrs: {
                          tiny: "",
                          text: _vm.$ct("sidebar.header-info"),
                        },
                      })
                    : _vm._e(),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-col",
        { attrs: { xs: "12", md: "7" } },
        [
          _c(
            "w-card",
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("sidebar.blocks")))]),
              _vm.sidebar.Blocks.length == 0
                ? _c(
                    "w-list-item",
                    [
                      _c("w-list-item-text", { staticClass: "gray" }, [
                        _vm._v(_vm._s(_vm.$ct("sidebar.no-blocks"))),
                      ]),
                    ],
                    1
                  )
                : _c(
                    "w-sortable",
                    {
                      attrs: {
                        items: _vm.sidebar.Blocks,
                        "disable-x": "",
                        "keep-in-y": "",
                        tag: "w-list",
                        "target-class": "handle",
                      },
                    },
                    _vm._l(_vm.sidebar.Blocks, function (block, i) {
                      return _c(
                        "w-list-item",
                        { key: i, attrs: { "show-handle": "" } },
                        [
                          _c(
                            "w-list-item-icon",
                            [
                              _c("w-fa", {
                                attrs: { icon: _vm.getBlockIcon(block) },
                              }),
                            ],
                            1
                          ),
                          _c("w-list-item-text", [
                            _c("span", [
                              _vm._v(
                                " " + _vm._s(_vm.getBlockTitle(block)) + " "
                              ),
                              _vm.getBlockSubtext(block)
                                ? _c("span", { staticClass: "gray" }, [
                                    _vm._v(
                                      "(" +
                                        _vm._s(_vm.getBlockSubtext(block)) +
                                        ")"
                                    ),
                                  ])
                                : _vm._e(),
                            ]),
                          ]),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("sidebar.edit-block"),
                                      expression: "$ct('sidebar.edit-block')",
                                    },
                                  ],
                                  on: {
                                    click: function ($event) {
                                      return _vm.editBlock(block)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "pen" } })],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "w-list-item-action",
                            [
                              _c(
                                "w-button",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: _vm.$ct("sidebar.remove-block"),
                                      expression: "$ct('sidebar.remove-block')",
                                    },
                                  ],
                                  staticClass: "danger",
                                  on: {
                                    click: function ($event) {
                                      return _vm.removeBlock(i)
                                    },
                                  },
                                },
                                [_c("w-fa", { attrs: { icon: "trash" } })],
                                1
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    1
                  ),
              _c(
                "w-list-item",
                {
                  on: {
                    click: function ($event) {
                      _vm.showAddBlock = true
                    },
                  },
                },
                [
                  _c(
                    "w-list-item-icon",
                    [_c("w-fa", { attrs: { icon: "plus" } })],
                    1
                  ),
                  _c("w-list-item-text", [
                    _vm._v(_vm._s(_vm.$ct("sidebar.add-block"))),
                  ]),
                ],
                1
              ),
              _vm.otherViews.length > 0
                ? _c(
                    "w-card-actions",
                    [
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: { icon: "copy" },
                          on: {
                            click: function ($event) {
                              _vm.showCopy = true
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$ct("sidebar.copy-to-views")))]
                      ),
                    ],
                    1
                  )
                : _vm._e(),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.showAddBlock,
            callback: function ($$v) {
              _vm.showAddBlock = $$v
            },
            expression: "showAddBlock",
          },
        },
        [
          _vm.showAddBlock
            ? _c("app-sidebar-add-block-modal", {
                attrs: { "browse-id": _vm.view.BrowseID },
                on: {
                  close: function ($event) {
                    _vm.showAddBlock = false
                  },
                  add: function ($event) {
                    return _vm.addBlock($event)
                  },
                  "add-template": function ($event) {
                    return _vm.addTemplate($event)
                  },
                },
              })
            : _vm._e(),
        ],
        1
      ),
      _c(
        "w-modal",
        {
          attrs: { "escape-close": "" },
          model: {
            value: _vm.showCopy,
            callback: function ($$v) {
              _vm.showCopy = $$v
            },
            expression: "showCopy",
          },
        },
        [
          _vm.showCopy
            ? _c(
                "w-card",
                { attrs: { "max-width": "520" } },
                [
                  _c("w-card-title", [
                    _vm._v(_vm._s(_vm.$ct("sidebar.copy-to-views"))),
                  ]),
                  _c(
                    "w-card-content",
                    [
                      _c("w-info", {
                        staticClass: "mb",
                        attrs: {
                          tiny: "",
                          text: _vm.$ct("sidebar.copy-to-views-info"),
                        },
                      }),
                      _vm._l(_vm.otherViews, function (v) {
                        return _c("w-checkbox", {
                          key: v.ID,
                          attrs: {
                            value: _vm.copyTargets.indexOf(v.ID) != -1,
                            label: v.Name,
                          },
                          on: {
                            input: function ($event) {
                              return _vm.toggleCopyTarget(v.ID)
                            },
                          },
                        })
                      }),
                    ],
                    2
                  ),
                  _c(
                    "w-card-actions",
                    [
                      _c(
                        "w-button",
                        {
                          staticClass: "cancel",
                          attrs: { icon: "ban" },
                          on: {
                            click: function ($event) {
                              _vm.showCopy = false
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.cancel")))]
                      ),
                      _c("w-spacer"),
                      _c(
                        "w-button",
                        {
                          attrs: {
                            icon: "check",
                            disabled:
                              _vm.copyTargets.length == 0 || _vm.copying,
                          },
                          on: {
                            click: function ($event) {
                              return _vm.copyToViews()
                            },
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.confirm")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              )
            : _vm._e(),
        ],
        1
      ),
      _vm.editingHeaderField && _vm.browse
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-sidebar-field-edit", {
                attrs: {
                  field: _vm.editingHeaderField,
                  browse: _vm.browse,
                  add: _vm.editingHeaderIndex == -1,
                },
                on: {
                  save: _vm.saveHeaderField,
                  cancel: function ($event) {
                    _vm.editingHeaderField = null
                  },
                },
              }),
            ],
            1
          )
        : _vm._e(),
      _vm.editingBlock
        ? _c(
            "w-modal",
            { attrs: { value: "" } },
            [
              _c("app-sidebar-block-edit", {
                attrs: {
                  block: _vm.editingBlock,
                  browse: _vm.browse,
                  add: _vm.editingIsNew,
                },
                on: { save: _vm.saveBlock, cancel: _vm.cancelEdit },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }